import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import Link from '@components/atoms/link/link';
import Environment from '@config/index';
import sanitizer from '@helpers/sanitizer';
import styles from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/modal-payment-installment.module.scss';

const Splitit = () => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.modalPaymentContainerm, styles['modalPaymentContainer--splitit'])}>
      <div className={clsx(styles.modalPayment__title, ' vc-modal__title')}>{t('MODAL_PAYMENT.SPLITIT.TITLE')}</div>

      <p className={styles.modalPayment__intro}>{t('MODAL_PAYMENT.SPLITIT.INTRO')}</p>

      <ul className={styles.modalPayment__list}>
        <li className={styles.modalPayment__item}>
          <Icon
            name="clock"
            className={clsx(styles.modalPayment__item__icon, styles['modalPayment__item__icon--clock'])}
          />

          <div className={styles.modalPayment__item__text}>
            <p className={styles.modalPayment__item__text__title}>{t('MODAL_PAYMENT.SPLITIT.QUICK_EASY_TITLE')}</p>

            <p className={styles.modalPayment__item__text__paragraph}>
              {t('MODAL_PAYMENT.SPLITIT.QUICK_EASY_PARAGRAPH')}
            </p>
          </div>
        </li>

        <li className={styles.modalPayment__item}>
          <img
            className={clsx(styles.modalPayment__item__icon, styles['modalPayment__item__icon--coins'])}
            src={`${Environment.cdnFolder}/assets/svg/coins.svg`}
            alt="coins"
          />

          <div className={styles.modalPayment__item__text}>
            <p className={styles.modalPayment__item__text__title}>{t('MODAL_PAYMENT.SPLITIT.INTEREST_TITLE')}</p>

            <p className={styles.modalPayment__item__text__paragraph}>
              {t('MODAL_PAYMENT.SPLITIT.INTEREST_PARAGRAPH')}
            </p>
          </div>
        </li>
      </ul>

      <div className={styles.modalPayment__note}>
        <div className={styles.modalPayment__note__title}>{t('MODAL_PAYMENT.SPLITIT.NOTE_TITLE')}</div>

        <p
          className={styles.modalPayment__note__text}
          dangerouslySetInnerHTML={{
            __html: sanitizer(t('MODAL_PAYMENT.SPLITIT.NOTE_PARAGRAPH')),
          }}
        />
      </div>

      <p className={styles.modalPayment__tips}>
        <span>{t('MODAL_PAYMENT.SPLITIT.TIPS.TEXT')}</span>

        <img
          className={styles.modalPayment__tips__logo}
          alt="modalPayment__tips__logo"
          src={`${Environment.cdnFolder}/assets/svg/carts/splitit.svg`}
        />

        <Link
          href="https://www.vestiairecollective.com/financing-splitit.shtml"
          target="_blank"
          className={styles.modalPayment__tips__link}
        >
          {t('MODAL_PAYMENT.SPLITIT.TIPS.LINK_TEXT')}
        </Link>
      </p>
    </div>
  );
};

export default Splitit;
